import React, { type ReactNode } from 'react';
import classNames from 'classnames';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

export type Props = {
	text: ReactNode;
	italic?: boolean;
	align?: 'left' | 'right';
	iconBefore?: ReactNode;
};

const GenericReadonlyCell = ({ text, italic = false, align = 'left', iconBefore }: Props) => {
	const rootClassNames = classNames({
		[styles.root]: true,
		[styles.alignRight]: align === 'right',
		italic,
	});
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={rootClassNames}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			{isDefined(iconBefore) && <div className={styles.iconBefore}>{iconBefore}</div>}
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.text}>{text}</div>
		</div>
	);
};

export default GenericReadonlyCell;
